export default "__VITE_ASSET__CJDiPQeW__"